import { createStore, applyMiddleware } from 'redux';
import createSagaMiddleware from 'redux-saga'
import { composeWithDevTools } from 'redux-devtools-extension';
import { combineReducers } from 'redux';

import reducers from './reducers';
import rootSaga from './sagas';

const sagaMiddleware = createSagaMiddleware();
const middleware = [sagaMiddleware];
const appReducer = combineReducers(reducers)
const rootReducer = (state, action) => {
    if (action.type === 'RESET_STORE' || action.type === 'LOGOUT') {
        state = undefined;
    }

    return appReducer(state, action);
}
const composeEnhancers = composeWithDevTools({
  // Specify name here, actionsBlacklist, actionsCreators and other options if needed
});

const store = createStore(rootReducer, composeEnhancers(
    applyMiddleware(...middleware)
));

sagaMiddleware.run(rootSaga);

export default store;
